export default "__VITE_ASSET__oLVLkIJh__"